// Nome file "friendly" per il PDF firmato: cliente_titolo_quotenumber.pdf
// Es. TEST_SRL_test_Q-2026-040.pdf — molto più leggibile di <uuid>-signed.pdf.
// Usato sia nello storage upload (SignaturePage) sia da flusia-core
// notifySignedHandler (allegato email + filename WhatsApp) che replica la
// stessa logica lato server.

interface SignedPdfNameParts {
  clientName?: string | null;
  dealTitle?: string | null;
  quoteNumber?: string | null;
  dealId: string;
}

function slugPart(raw: string | null | undefined, maxLen: number): string {
  if (!raw) return '';
  return raw
    .toString()
    .trim()
    // Via gli accenti (Romanò -> Romano): lo storage Supabase rifiuta con 400 le
    // chiavi con caratteri non ASCII, e la firma falliva per chiunque avesse una
    // lettera accentata nel nome (21/09/2026)
    .normalize('NFD')
    .replace(/\p{M}/gu, '')
    // Rimuovi caratteri non sicuri per filename (mantieni lettere/numeri ASCII/spazi/-/_)
    .replace(/[^A-Za-z0-9\s\-_]/g, '')
    .replace(/\s+/g, '_')
    .substring(0, maxLen)
    // No trailing underscore da troncamento
    .replace(/_+$/, '');
}

export function buildSignedPdfName(parts: SignedPdfNameParts): string {
  const client = slugPart(parts.clientName, 40);
  const title = slugPart(parts.dealTitle, 30);
  // quote_number è l'id univoco leggibile; fallback primi 8 char del deal UUID
  const uniqueId = slugPart(parts.quoteNumber, 20) || parts.dealId.substring(0, 8);

  const segments = [client, title, uniqueId].filter(Boolean);
  return `${segments.join('_')}.pdf`;
}
